import { Flex, StyleProps, Text } from "@chakra-ui/react";
import React from "react";

interface AiInterviewerSectionTitleProps extends StyleProps {
  title: string;
  rightContent?: React.ReactNode;
}

const AiInterviewerSectionTitle: React.FC<AiInterviewerSectionTitleProps> = ({
  title,
  rightContent,
  ...styles
}) => {
  return (
    <Flex
      flexDirection="row"
      alignItems="baseline"
      justifyContent="space-between"
      w="100%"
      mb={6}
      lineHeight="6"
      {...styles}
    >
      <Text fontSize="md" fontWeight="semibold">
        {title}
      </Text>
      {rightContent}
    </Flex>
  );
};

export default AiInterviewerSectionTitle;
